@if (loading || freightRateGroupNames.length > 0) {
  <div>
    @if (batchActionsAvailable()) {
      <div>
        @if (
          quote().getQuoteType() === quoteType.fcl &&
          freightRateGroupNames.length > 0
        ) {
          <div class="row header-batch-actions">
            <div class="col-sm-6">
              <span class="box-header">Batch contract update</span>
            </div>
            <div class="col-sm-6">
              <span class="box-header">Batch margin update</span>
            </div>
          </div>
        }
        @if (
          quote().getQuoteType() === quoteType.fcl &&
          freightRateGroupNames.length > 0
        ) {
          <div class="row box-batch-actions">
            <div class="col-12 col-md-6">
              @if (isBatchServiceSelectVisible()) {
                <app-freight-rate-batch-select
                  [saving]="batchSelectionSaving"
                  (selectionChange)="onBatchSelectionChange($event)"
                  [freightRateGroups]="freightRateGroups"
                  [locationKindFilterOptions]="locationKindFilterOptions()"
                >
                </app-freight-rate-batch-select>
              }
              <i class="pi right-arrow pi-angle-right"></i>
            </div>
            <div class="col-12 col-md-6">
              <app-freight-rate-batch-margin
                [equipment]="equipment()"
                [selectedTier]="selectedTier"
                [freightRateGroups]="freightRateGroups"
                [saving]="batchMarginSaving"
                (routesChange)="onBatchMarginUpdate($event)"
              >
              </app-freight-rate-batch-margin>
            </div>
          </div>
        }
      </div>
    }
    @for (groupName of freightRateGroupNames; track groupName; let i = $index) {
      <div
        data-cy="rate-total-group"
        class="rate-total-group"
        (appInViewport)="onLaneSeen(groupName)"
      >
        <div class="rate-group-header">
          <i aria-hidden="true" class="pi pi-map-marker"></i>
          <span class="origin">{{
            freightRateGroups[groupName].originLabel
          }}</span>
          <i aria-hidden="true" class="pi pi-arrow-right"></i>
          <i aria-hidden="true" class="pi pi-map-marker"></i>
          <span class="destination">{{
            freightRateGroups[groupName].destinationLabel
          }}</span>
          @if (exportable) {
            <i aria-hidden="true" class="pi pi-download" (click)="export()"></i>
          }
          @if (showsAgentRequests()) {
            <app-agent-request-links
              label="Request rate from agent"
              [count]="
                agentRequestCounts.forLane(
                  freightRateGroups[groupName].quoteOriginLocationId,
                  freightRateGroups[groupName].quoteDestinationLocationId
                )
              "
              [queryParams]="laneAgentRequestParams()"
              (requested)="requestRatesFromAgent(freightRateGroups[groupName])"
            />
          }
        </div>
        @defer (on viewport) {
          <app-table
            data-cy="quote-table"
            dataKey="rowKey"
            emptyMessage="No rates found."
            addLabel="Add rate"
            [columns]="freightRateGroups[groupName].columns"
            [selectable]="true"
            [headerSelectable]="false"
            [editable]="true"
            [onlineCarriers]="freightRateGroups[groupName].onlineCarriers"
            [searchAllSkips]="searchAllSkips()"
            [searchCredits]="searchCredits"
            [addable]="addable"
            [loading]="loading || refreshingRows"
            [skeletonRowCount]="
              refreshingRows
                ? skeletonRowCount(freightRateGroups[groupName])
                : null
            "
            [loadingMoreRows]="
              freightRateGroups[groupName].loadingPartnerOnlineRates
            "
            [rowDisabled]="isRowDisabled"
            [rowSelectable]="
              shouldValidateRowSelection() ? isRowSelectable : undefined
            "
            [value]="freightRateGroups[groupName].freightRates"
            [newValue]="freightRateGroups[groupName].newFreightRate"
            (selectRow)="onRowSelect($event)"
            (loadOnlineCarrier)="
              onLoadOnlineCarrier(freightRateGroups[groupName], $event)
            "
            (searchAllowanceReached)="onSearchAllowanceReached()"
            (unSelectRow)="onRowUnselect($event)"
            [(selection)]="freightRateGroups[groupName].selection"
            (saveRow)="onSaveFreightRate($event)"
            (sortRows)="sortRates(groupName, $event.field, $event.order)"
          >
          </app-table>
        } @placeholder {
          <div
            data-cy="quote-table-placeholder"
            [style.min-height.px]="
              tablePlaceholderHeight(freightRateGroups[groupName])
            "
          ></div>
        }
      </div>
    }
  </div>
}

@if (maerskLocationsVisible) {
  <app-quote-maersk-locations
    [quote]="quote()"
    (closeView)="maerskLocationsVisible = false"
    (fetchRates)="
      maerskLocationsVisible = false;
      onLoadMaerskRows(
        currentFreightRateGroup,
        $event.originGeoId,
        $event.destinationGeoId
      )
    "
  >
  </app-quote-maersk-locations>
}

@if (agentRequestTarget) {
  <app-agent-request-dialog
    [quote]="quote()"
    [target]="agentRequestTarget"
    (sent)="onAgentRequestsSent()"
    (closed)="agentRequestTarget = null"
  />
}
